import { useSelector } from "react-redux";
import SelectAttributesDropdown from "./selectAttributesDropdrown";
import store from "../../stores/store";
import { useEffect, useRef, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar, Pie, Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function FeaturesChart(props) {
  const layers = useSelector((state) => store.getState().layers);

  const [xaxis, setXAxis] = useState(null);
  const [yaxis, setYAxis] = useState(null);
  const [chartType, setChartType] = useState("bar");

  const chartBarRef = useRef();
  const chartLineRef = useRef();
  const chartPieRef = useRef();

  useEffect(() => {
    updateCharts();
  }, [xaxis, yaxis, chartType]);

  function updateCharts() {
    let theChart = null;

    switch (chartType) {
      case "bar":
        theChart = chartBarRef;
        break;

      case "line":
        theChart = chartLineRef;
        break;

      case "pie":
        theChart = chartPieRef;
        break;
    }

    if (theChart) {
      if (theChart.current) {
        theChart.current.update();
      }
    }
  }

  return (
    <div className="mt-2 mb-2">
      <div className="row">
        <div className="col-md-4">
          <div className="mt-2">
            <label className="color-get-blue strong ">Axis X</label>
            <div className="mt-1">
              <SelectAttributesDropdown
                attributes={layers[props.layer]?.attributes}
                onChange={(e) => {
                  setXAxis(e.target.value);
                }}
              ></SelectAttributesDropdown>
            </div>
          </div>
          <div className="mt-2">
            <label className="color-get-blue strong ">Axis Y</label>
            <div className="mt-1">
              <SelectAttributesDropdown
                attributes={layers[props.layer]?.attributes}
                onChange={(e) => {
                  setYAxis(e.target.value);
                }}
              ></SelectAttributesDropdown>
            </div>
          </div>
          <div className="mt-2">
            <label className="color-get-blue strong ">Diagram type</label>
            <div className="mt-1">
              <select
                className="form-select form-select-sm"
                onChange={(e) => {
                  setChartType(e.target.value);
                }}
              >
                <option value="pie">Pie</option>
                <option value="bar">Bar</option>
                <option value="line">Line</option>
              </select>
            </div>
          </div>
          <div className="col-3">
            <label className="color-get-blue strong "></label>
            <div className="mt-1">
              <button className="btn btn-sm btn-secondary text-white">
                Show chart
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-8">
          {chartType === "bar" && xaxis && yaxis ? (
            <Bar
              ref={chartBarRef}
              options={{
                parsing: {
                  xAxisKey: xaxis,
                  yAxisKey: yaxis,
                },
              }}
              data={{
                datasets: [
                  {
                    data: [...props.features],
                  },
                ],
              }}
              className="w-100"
            />
          ) : (
            ""
          )}
          {chartType === "line" && xaxis && yaxis ? (
            <Line
              ref={chartLineRef}
              options={{
                parsing: {
                  xAxisKey: xaxis,
                  yAxisKey: yaxis,
                },
              }}
              data={{
                datasets: [
                  {
                    data: [...props.features],
                  },
                ],
              }}
              className="w-100"
            />
          ) : (
            ""
          )}
          {chartType === "pie" && xaxis && yaxis ? (
            <Pie
              ref={chartPieRef}
              options={{
                parsing: {
                  xAxisKey: xaxis,
                  yAxisKey: yaxis,
                },
              }}
              data={{
                datasets: [
                  {
                    data: [...props.features],
                  },
                ],
              }}
              className="w-100"
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}

export default FeaturesChart;
